import styled from '@emotion/styled';
import { pxToRem } from '../../../../styles/utils';
import { Flexbox } from '../../../Flexbox';

interface StickySidebarWrapperProps {
  top: number;
}

export const StickySidebarWrapper = styled(Flexbox)<StickySidebarWrapperProps>`
  flex-direction: column;
  position: sticky;
  top: ${({ top }) => pxToRem(top)};
  gap: ${({ theme }) => theme.spacing.ml};

  *:first-child {
    margin-top: 0;
  }
`;
